import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utilities/axios';

export const addBalanceRecord = createAsyncThunk(
  'employeeBalance/addBalanceRecord',
  async ({ userId, balanceData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/employee-balance/${userId}`, {
        startDate: balanceData.startDate,
        balance: parseFloat(balanceData.balance)
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchBalanceRecords = createAsyncThunk(
  'employeeBalance/fetchBalanceRecords',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/employee-balance/${userId}`);
      return response.data.records || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateBalanceRecord = createAsyncThunk(
  'employeeBalance/updateBalanceRecord',
  async ({ recordId, newBalance }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/employee-balance/${recordId}`, {
        balance: parseFloat(newBalance)
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteBalanceRecord = createAsyncThunk(
  'employeeBalance/deleteBalanceRecord',
  async (recordId, { rejectWithValue }) => {
    try {
      await axios.delete(`/employee-balance/${recordId}`);
      return recordId;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  records: [],
  loading: false,
  error: null,
  submitting: false
};

const slice = createSlice({
  name: 'employeeBalance',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBalanceRecord.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(addBalanceRecord.fulfilled, (state, action) => {
        state.submitting = false;
        state.records.push(action.payload);
      })
      .addCase(addBalanceRecord.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      })
      .addCase(fetchBalanceRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBalanceRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.records = action.payload;
      })
      .addCase(fetchBalanceRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBalanceRecord.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(updateBalanceRecord.fulfilled, (state, action) => {
        state.submitting = false;
        const index = state.records.findIndex(record => record._id === action.payload._id);
        if (index !== -1) {
          state.records[index] = action.payload;
        }
      })
      .addCase(updateBalanceRecord.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      })
      .addCase(deleteBalanceRecord.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(deleteBalanceRecord.fulfilled, (state, action) => {
        state.submitting = false;
        state.records = state.records.filter(record => record._id !== action.payload);
      })
      .addCase(deleteBalanceRecord.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = slice.actions;
export const reducer = slice.reducer;
export default slice;